"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sambuca-pistoiese": {
    "4a22f0a0": [{
      "hkey": "22c78bfa",
      "slug": "sambuca-pistoiese",
      "name": "Sambuca Pistoiese",
      "primary": true,
      "skipSearch": false
    }],
    "casale": [{
      "hkey": "22c78bfa",
      "slug": "sambuca-pistoiese",
      "name": "Sambuca Pistoiese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1993b0d3": [{
      "hkey": "22c78bfa",
      "slug": "sambuca-pistoiese",
      "name": "Sambuca Pistoiese",
      "primary": true,
      "skipSearch": false
    }],
    "posala": [{
      "hkey": "22c78bfa",
      "slug": "sambuca-pistoiese",
      "name": "Sambuca Pistoiese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "559f1b04": [{
      "hkey": "80a0de1a",
      "slug": "san-pellegrino-al-cassero-casoni",
      "name": "San Pellegrino al Cassero-Casoni",
      "primary": true,
      "skipSearch": false
    }],
    "san-pellegrino-al-cassero": [{
      "hkey": "80a0de1a",
      "slug": "san-pellegrino-al-cassero-casoni",
      "name": "San Pellegrino al Cassero-Casoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;